import { render } from "./ParticipantPayments.vue?vue&type=template&id=4b7547d5"
import script from "./ParticipantPayments.vue?vue&type=script&lang=js"
export * from "./ParticipantPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__